import { Component } from '@angular/core';
import { EntityCrud } from '../../../shared/working/entity-crud/entity-crud';
import { ENTITY_CONFIGS } from '../entity-configs';

@Component({
  imports: [EntityCrud],
  selector: 'app-md-d8d07776',
  styleUrl: './md-d8d07776.css',
  templateUrl: './md-d8d07776.html',
})
export class MdD8d07776 { readonly config = ENTITY_CONFIGS['d8d07776']; }
